// Hide Header on on scroll down
var didScroll
var lastScrollTop = 0
var delta = 5
var navbarHeight = $('.nav-scroll').outerHeight()

$(window).scroll(function(event) {
  didScroll = true
})

setInterval(function() {
  if (didScroll) {
    hasScrolled()
    didScroll = false
  }
}, 250)

function hasScrolled() {
  var st = $(this).scrollTop()

  // Make sure they scroll more than delta
  if (Math.abs(lastScrollTop - st) <= delta) return

  // If they scrolled down and are past the navbar, add class .nav-up.
  // This is necessary so you never see what is "behind" the navbar.
  if (st > lastScrollTop && st > navbarHeight) {
    // Scroll Down
    $('.nav-scroll')
      .removeClass('nav-down')
      .addClass('nav-up')
  } else {
    // Scroll Up
    if (st + $(window).height() < $(document).height()) {
      $('.nav-scroll')
        .removeClass('nav-up')
        .addClass('nav-down')
    }
  }

  lastScrollTop = st
}

/* Slick slider init */
$('.services').slick({
  centerMode: true,
  prevArrow: $('.arrow-prev'),
  nextArrow: $('.arrow-next'),
  centerPadding: '100px',
  slidesToShow: 4,
  responsive: [
    {
      breakpoint: 1580,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1,
      },
    },
  ],
})

$('.carrieres').slick({
  centerMode: true,
  prevArrow: $('.arrow-prev2'),
  nextArrow: $('.arrow-next2'),
  centerPadding: '100px',
  slidesToShow: 4,
  responsive: [
    {
      breakpoint: 1580,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1,
      },
    },
  ],
})
